import React, { Component } from 'react'
import { DataRow, Icon } from 'Common/components';

export const TheField = ({ label, value, name, horizontal, vertical, condition, isCheckbox, size, value_postfix }) => {
    let _value = (condition) ? condition(value) : value;
    
    if (isCheckbox) {
        if (_value == 'yes') _value = <Icon icon="check" color="green" />
        if (_value == 'no') _value = <Icon icon="times" color="red" />
        return <DataRow col1={`${_value} ${value_postfix || ""}`} col2={label} inline size={size} />
    }
    if (horizontal) return <DataRow col1={label} col2={`${_value} ${value_postfix || ""}`} inline size={size} />
    if (vertical) return <DataRow col1={label} col2={`${_value} ${value_postfix || ""}`} size={['100%', '100%']} />
    return (<DataRow col1={label} col2={`${_value} ${value_postfix || ""}`} size={size} />)
}
